export function createInjurySummaryObject(injurySummaryDataObject) {

  let injurySummaryDataReturnObj = {};
  Object.keys(injurySummaryDataObject).forEach(key =>{
    injurySummaryDataReturnObj[key] = injurySummaryDataObject[key];
  });

  if(injurySummaryDataReturnObj.tcr || injurySummaryDataReturnObj.tcr == 0){
    if(injurySummaryDataReturnObj.tcr.toString().indexOf(".") == -1){
      injurySummaryDataReturnObj.tcr = injurySummaryDataReturnObj.tcr + ".0";
    }
  }

  if(injurySummaryDataReturnObj.dart  || injurySummaryDataReturnObj.dart == 0){
    if(injurySummaryDataReturnObj.dart.toString().indexOf(".") == -1){
      injurySummaryDataReturnObj.dart = injurySummaryDataReturnObj.dart + ".0";
    }
  }

  return {
      noInjuries :  injurySummaryDataReturnObj.no_injuries_illnesses,
      totalDeaths :injurySummaryDataReturnObj.total_deaths,
      totalDafwCases : injurySummaryDataReturnObj.total_dafw_cases,
      totalDjtrCases : injurySummaryDataReturnObj.total_djtr_cases,
      totalOtherCases : injurySummaryDataReturnObj.total_other_cases,
      totalDafwDays : injurySummaryDataReturnObj.total_dafw_days,
      totalDjtrDays : injurySummaryDataReturnObj.total_djtr_days,
      totalInjuries : injurySummaryDataReturnObj.total_injuries,
      totalSkinDisorders : injurySummaryDataReturnObj.total_skin_disorders,
      totalRespiratoryConditions : injurySummaryDataReturnObj.total_respiratory_conditions,
      totalPoisonings : injurySummaryDataReturnObj.total_poisonings,
      totalHearingLoss : injurySummaryDataReturnObj.total_hearing_loss,
      totalOtherIllnesses : injurySummaryDataReturnObj.total_other_illnesses,
      annualAverageEmployees : injurySummaryDataReturnObj.annual_average_employees,
      totalHoursWorked : injurySummaryDataReturnObj.total_hours_worked,
      filingYear : injurySummaryDataReturnObj.year_filing_for,
      id: injurySummaryDataReturnObj.id || null,
      establishmentId: injurySummaryDataReturnObj.establishment_id || null,
      tcr: injurySummaryDataReturnObj.tcr,
      dart: injurySummaryDataReturnObj.dart,
      totalExpectedCases: injurySummaryDataReturnObj.total_expected_cases,
      totalSubmittedCases: injurySummaryDataReturnObj.total_submitted_cases,
      totalOtherCasesCount: injurySummaryDataReturnObj.total_other_cases_count,
      totalDjtrCasesCount: injurySummaryDataObject.total_djtr_cases_count,
      totalDafwCasesCount: injurySummaryDataObject.total_dafw_cases_count,
      totalDeathCasesCount: injurySummaryDataObject.total_death_cases_count
  };
}

export function createInjurySummaryDataObject(injurySummary) {
  return {
    id: injurySummary.id || null,
    establishment: injurySummary.establishment || null,
    no_injuries_illnesses: injurySummary.noInjuries,
    total_deaths: injurySummary.totalDeaths,
    total_dafw_cases: injurySummary.totalDafwCases,
    total_djtr_cases: injurySummary.totalDjtrCases,
    total_other_cases: injurySummary.totalOtherCases,
    total_dafw_days: injurySummary.totalDafwDays,
    total_djtr_days: injurySummary.totalDjtrDays,
    total_injuries: injurySummary.totalInjuries,
    total_skin_disorders: injurySummary.totalSkinDisorders,
    total_respiratory_conditions: injurySummary.totalRespiratoryConditions,
    total_poisonings: injurySummary.totalPoisonings,
    total_hearing_loss: injurySummary.totalHearingLoss,
    total_other_illnesses: injurySummary.totalOtherIllnesses,
    annual_average_employees: injurySummary.annualAverageEmployees,
    total_hours_worked: injurySummary.totalHoursWorked,
    year_filing_for: injurySummary.filingYear
  };
}



/** WEBPACK FOOTER **
 ** ./src/components/injurySummary/injurySummaryModel.js
 **/